import { render, staticRenderFns } from "./MediaTendency.vue?vue&type=template&id=3d30ee86"
import script from "./MediaTendency.vue?vue&type=script&lang=js"
export * from "./MediaTendency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports